export default __webpack_public_path__ + "static/media/brand17.d6827872.svg";